module.exports = __webpack_public_path__ + "img/SES_4000000801.beef51a3.jpg";